// MainRoutes.js

import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import MainLayout from 'layout/MainLayout';
import Loadable from 'utilities/Loadable';
import MobileLayout from 'layout/MobileLayout';

const MapView = Loadable(lazy(() => import('views/MapView')));
const NotFound = Loadable(lazy(() => import('views/pages/PageNotFound')));

export const MobileRoutes = {
  path: '/entry/*',
  element: <MobileLayout />

};

// /entry/grid and /entry/table are retired — redirect any bookmarks or stale
// links to the map view. Remove the redirects once no usage appears in logs.
export const MainRoutes = {
  path: '/entry',
  element: <MainLayout />,
  children: [
    {
      path: 'map',
      element: <MapView />
    },
    {
      path: 'grid',
      element: <Navigate to="/entry/map" replace />
    },
    {
      path: 'table',
      element: <Navigate to="/entry/map" replace />
    },
    {
      path: '*/',
      element: <NotFound />,
    }
  ],

};
